class CartUpsell {
  constructor() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-upsell-item__add-btn');
      if (btn) this.addToCart(btn);
    });
  }

  async addToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });

      if (!addResponse.ok) {
        const err = await addResponse.json();
        throw new Error(err.description || 'Failed to add to cart');
      }

      await this.refreshCartDrawer();

      btn.textContent = '✓ Added';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    } catch {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  }

  async refreshCartDrawer() {
    const response = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
    const data = await response.json();

    const drawerInner = document.querySelector('cart-drawer .drawer__inner');
    if (drawerInner && data['cart-drawer']) {
      drawerInner.innerHTML = this.getSectionInnerHTML(data['cart-drawer'], '.drawer__inner');
      // Re-bind overlay click after DOM replacement
      const overlay = document.getElementById('CartDrawer-Overlay');
      const cartDrawer = document.querySelector('cart-drawer');
      if (overlay && cartDrawer) {
        overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }
    }

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && data['cart-icon-bubble']) {
      cartIconBubble.innerHTML = this.getSectionInnerHTML(data['cart-icon-bubble']);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? '';
  }
}

new CartUpsell();
